export const getReflectionTranslations = (
  t: (key: string, defaultValue?: string) => string
) => ({
  categories: {
    organization: {
      title: t(
        "frontend.futurebilityCockpit.categories.organization.title",
        "Organization"
      ),
    },
    team: {
      title: t("frontend.futurebilityCockpit.categories.team.title", "Team"),
    },
    leadership: {
      title: t(
        "frontend.futurebilityCockpit.categories.leadership.title",
        "Leadership"
      ),
    },
  },
  personalityMatrix: {
    labels: {
      left: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.left",
        "Community-oriented"
      ),
      leftSub: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.leftSub",
        "Success-oriented"
      ),
      right: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.right",
        "Success-oriented"
      ),
      rightSub: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.rightSub",
        "Success-oriented"
      ),
      top: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.top",
        "Opportunity-oriented"
      ),
      topSub: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.topSub",
        "Risk-taking"
      ),
      bottom: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.bottom",
        "Security-oriented"
      ),
      bottomSub: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.bottomSub",
        "Risk-avoiding"
      ),
      topLeft: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.topLeft",
        "Mediator"
      ),
      topRight: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.topRight",
        "Innovator"
      ),
      bottomLeft: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.bottomLeft",
        "Brake"
      ),
      bottomRight: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.bottomRight",
        "Driver"
      ),
      grid1: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.grid1",
        "Consultant"
      ),
      grid2: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.grid2",
        "Advisor"
      ),
      grid3: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.grid3",
        "Motivator"
      ),
      grid4: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.grid4",
        "Controller"
      ),
      grid5: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.grid5",
        "Director"
      ),
      grid6: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.grid6",
        "Critic"
      ),
      grid7: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.grid7",
        "Obstacle"
      ),
      grid8: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.grid8",
        "Blocker"
      ),
      grid9: t(
        "frontend.futurebilityCockpit.personalityMatrix.labels.grid9",
        "Pusher"
      ),
    },
    content: {
      left: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.left",
        "Community-oriented content"
      ),
      right: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.right",
        "Success-oriented content"
      ),
      top: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.top",
        "Opportunity-oriented content"
      ),
      bottom: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.bottom",
        "Security-oriented content"
      ),
      topLeft: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.topLeft",
        "Mediator content"
      ),
      topRight: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.topRight",
        "Innovator content"
      ),
      bottomLeft: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.bottomLeft",
        "Brake content"
      ),
      bottomRight: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.bottomRight",
        "Driver content"
      ),
      grid1: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.grid1",
        "Consultant content"
      ),
      grid2: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.grid2",
        "Advisor content"
      ),
      grid3: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.grid3",
        "Motivator content"
      ),
      grid4: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.grid4",
        "Controller content"
      ),
      grid5: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.grid5",
        "Director content"
      ),
      grid6: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.grid6",
        "Critic content"
      ),
      grid7: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.grid7",
        "Obstacle content"
      ),
      grid8: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.grid8",
        "Blocker content"
      ),
      grid9: t(
        "frontend.futurebilityCockpit.personalityMatrix.content.grid9",
        "Pusher content"
      ),
    },
  },
});
